/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Baby(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M131.92139,24.0813C120.32031,40.37354,120.002,55.87939,120,56.044A8.00006,8.00006,0,0,0,136,56a8,8,0,0,1,16,0,24,24,0,0,1-48,0c0-.72876.125-14.4248,8.57715-30.85474a104.06072,104.06072,0,1,0,19.34424-1.064ZM80,128a12,12,0,1,1,12,12A12,12,0,0,1,80,128Zm78.9668,46.665a56.03047,56.03047,0,0,1-61.93213.001,7.99982,7.99982,0,1,1,8.85742-13.32422,40.03347,40.03347,0,0,0,44.21777-.001A7.99969,7.99969,0,1,1,158.9668,174.665ZM164,140a12,12,0,1,1,12-12A12,12,0,0,1,164,140Z" />
    </Svg>
  );
}

export default Baby;
